import useCurrentUser from '../queries/currentUser/useCurrentUser'

const useCurrentUserIdSelector = () => useCurrentUser()?.data?.id

export default useCurrentUserIdSelector
